<template>
  <div>
    <div>
      <button type="button" class="btn btn--green my-3" @click="addEducation()">{{ __('misc.add') }}
      </button>
      <div v-if="permission_applicant_education == 3 && educations.length == 0">
            <input type="hidden" class="requiredQuestion" :custom-message=customMessage />
      </div>
    </div>
    <div class="row py-2 px-4 justify-content-between">
      <div
        class="form-group hrtcard shadow my-3 p-3 col-12 col-md-5"      
        v-for="(row, index_education) in educations"
        v-bind:key=index_education
      >
        <div class="d-flex justify-content-end col-12 mb-2">
                <button
                  type="button"
                  class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove"
                  @click="rmEducation(index_education)"
                >
                <i class="fas fa-trash"></i>
                </button>
        </div>        
        <div class="col-12 mb-1">
          <label> {{ __('views.Educations.title') }} </label>
          <select
            class="form-control"
            :class="{'requiredQuestion': permission_applicant_education == 3}"
            :name="
              'question[' +
              question_id +
              '][education_data][' +
              index_education +
              '][education_id]'
            "
          >
            <option value="">---</option>
            <option
              v-for="(lang, index_education) in educations_props"
              :value="lang.id"
              v-bind:key=index_education
            >
              {{ lang.name }}
            </option>
          </select>
        </div>
        
        <div class="col-12 mb-1"
          v-for="(element, index_element) in collection_educations_eavs"                
          v-bind:key=index_element
        >        
          <label>{{ element.label }}</label>
          <div v-if="element.type == 'string'">
            <input
              type="text"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][education_data][' +
                index_education +
                '][' +
                element.key +
                ']'
              "
            />
          </div>
          <div v-if="element.type == 'date'">
            <input
              type="date"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][education_data][' +
                index_education +
                '][' +
                element.key +
                ']'
              "
            />
          </div>
          <div v-if="element.type == 'number'">
            <input
              type="number"
              class="form-control"
              value=""
              :name="
                'question[' +
                question_id +
                '][education_data][' +
                index_education +
                '][' +
                element.key +
                ']'
              "
            />
          </div>
          <div v-if="element.type == 'select'">
            <select
              class="form-control"
              :name="
                'question[' +
                question_id +
                '][education_data][' +
                index_education +
                '][' +
                element.key +
                ']'
              "
            >
              <option v-for="(opt, index) in element.options" :value="index" v-bind:key=index>
                {{ opt }}
              </option>
            </select>
          </div>
          <div v-if="element.type == 'radio' || element.type == 'radiobutton'">
            <div v-for="(opt, index) in element.options" v-bind:key=index>
              <input
                class="form-check-input"
                type="radio"
                :name="
                  'question[' +
                  question_id +
                  '][education_data][' +
                  index_education +
                  '][' +
                  element.key +
                  ']'
                "
                :value="index"
              />
              <label class="form-check-label">
                {{ opt }}
              </label>
            </div>
          </div>
          <div v-if="element.type == 'checkbox'">
            <div v-for="(opt, index) in element.options" v-bind:key=index>
              <input
                class="form-check-input"
                type="checkbox"
                :name="
                  'question[' +
                  question_id +
                  '][education_data][' +
                  index_education +
                  '][' +
                  element.key +
                  '][' +
                  index +
                  ']'
                "
                :value="index"
              />
              <label class="form-check-label">
                {{ opt }}
              </label>
            </div>
          </div>      
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  created() {},

  mounted() {
    this.customMessage = this.__('forms.educations.required-custom-message');
  },
  props: {
    educations_props: {
      type: Array,
      required: true,
    },
    question_id: {
      type: Number,
      required: true,
    },
    collection_educations_eavs: {
      type: Array,
      required: true,
    },
    permission_applicant_education: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      educations: [],
      customMessage: null
    };
  },
  methods: {
    rmEducation(index) {
      this.educations.splice(index, 1);
    },
    addEducation() {
      this.educations.push([]);
    },
  },
};
</script>